// Imports
import { Base, DataTypes, SubmitTypes, ErrorTypes } from '@mixins/forms'
import { track } from '@plugins/tracking'

// Parts
const { ObjectDataType: dataType } = DataTypes
const { AjaxSubmit: submitType } = SubmitTypes
const { DummyError: errorHandling } = ErrorTypes
const SERVICE = "services";

// Options
const options = {
  dataType,
  submitType,
  errorHandling,
  submitOnChange: false,
  skipValidation: false,
  tracking: {
    view: true,
    validation: true,
    submit: {},
    error: true
  }
}

export default {
  name: 'sitecore-form',
  mixins: [
    Base(options)
  ],
  data: () => ({
    finalMsg: null,
    grecaptchaToken: '',
    grecaptchaReady: false
  }),
  computed: {
    innerScope() {
      return {
        finalMsg: this.finalMsg,
        grecaptchaCallback: this.grecaptchaCallback,
        grecaptchaExecute: this.grecaptchaExecute,
        grecaptchaToken: this.grecaptchaToken,
        grecaptchaReady: this.grecaptchaReady,
        grecaptchaReadyCallback: this.grecaptchaReadyCallback
      }
    }
  },
  methods: {
    transformData(data) {
      this.finalMsg = null
      const parsedData = this.parseData(data)
      const isFeedback = this.getIsFeedback(parsedData)
      const body = this.createBody(parsedData)
      const service = this.getService(parsedData)
      const datasourceId = this.getDatasourceId()
      //Adobe V2 Tagging for sitecore forms
      if (window.adobeDataLayer) {
        this.formEventTagging(parsedData)
      }
      return {
        datasourceId,
        body,
        isFeedback,
        service,
        grecaptchaCallback: this.grecaptchaCallback,
        grecaptchaExecute: this.grecaptchaExecute,
        grecaptchaToken: this.grecaptchaToken,
        grecaptchaReady: this.grecaptchaReady,
        grecaptchaReadyCallback: this.grecaptchaReadyCallback
      }
    },
    transformResponse() {
      this.finalMsg = this.getFinalMsg()
      this.form.trigger('reset')
      this.$root.$emit('reset-date-field')
    },
    parseData(data) {
      const parsedData = {}
      Object.keys(data).forEach((key) => {
        if (key.includes('.ItemId')) {
          const { label, value } = this.getLabelAndValue(key, data)
          if (value) {
            parsedData[label] = value
          }
        } else if (key.includes('checkboxList-')) {
          const { label, value } = this.getLabelAndValue(key, data)
          if (value) {
            if (!parsedData[label]) {
              parsedData[label] = []
            }
            parsedData[label].push(value)
          }
        }
      })
      return parsedData
    },
    getLabelAndValue(key, data) {
      const valueKey = key.replace('.ItemId', '.Value')
      const valueEl = this.form.find(`[name="${valueKey}"]`)
      const valueElId = valueEl.attr('id')
      const valueDataType = valueEl.attr('data-field')
      let value = data[valueKey]
      let labelEl = this.form.find(`label[for="${valueElId}"]`)
      if (valueDataType === 'PhoneNumber' || valueDataType === 'PhoneField' || valueDataType === 'Phone') {
        const mainInput = this.form.find(`input[data-for="${valueElId}"]`)
        const mainInputId = mainInput.attr('id')
        labelEl = this.form.find(`label[for="${mainInputId}"]`)
      } else if (labelEl.attr('data-field-type') === 'RadioButtonList' && value) {
        const parent = valueEl.parent().parent()
        labelEl = parent.find('.radio-group-title')
      } else if (labelEl.attr('data-field-type') === 'CheckBox') {
        value = value ? 'Yes' : 'No'
      } else if (labelEl.attr('data-field-type') === 'CheckboxList' && value) {
        const parent = valueEl.parent().parent()
        labelEl = parent.find('.checkbox-title')
      }
      let label = labelEl ? labelEl.text().trim() : ''
      return { value, label }
    },
    getDatasourceId() {
      const FormDataSourceId = this.form.find('[data-sc-field-name="FormDatasourceId"]')
      return FormDataSourceId.attr('data-sc-parameters')
    },
    getIsFeedback() {
      const isFeedback = this.form.find('[data-sc-field-name="IsFeedback"]')
      return isFeedback.attr('data-sc-parameters')
    },
    getFinalMsg(data) {
      const finalMsgEl = this.form.find('[data-sc-field-name="FinalMsg"]')
      return finalMsgEl.attr('data-sc-parameters')
    },
    formEventTagging(data) {
      const mastheadEyebrow = document.querySelector('.masthead-eyebrow')
      const hotelName = mastheadEyebrow ? mastheadEyebrow.textContent.trim() : ""
      const hoteNameFinal = hotelName ? '-' + hotelName : ''
      const pathname = window.location.pathname
      if (pathname.includes('/spa/book-treatment')) {
        track({
          event: 'spaResFormSub',
          spaTreatment: 'Misc' + hoteNameFinal
        })
      } else if (pathname.includes('/meet/request-for-proposal') || pathname.includes('/celebrate/request-for-proposal')) {
        track({
          event: 'eventResFormSub',
          eventResType: data["Type of event"]
        })
      } else if (pathname.includes('/dine/request-reservation')) {
        track({
          event: 'diningResFormSub',
          restaurant: hotelName + '-' + data["Restaurant"]
        })
      } else {
        return
      }
    },
    createBody(data) {
      const rows = []
      Object.keys(data).forEach(key => {
        const value = data[key]
        rows.push(`<tr><td>${key}: <td><td>${value}</td></tr>`)
      })
      let utf8Bytes = encodeURIComponent(`<table>${rows.join('')}</table>`).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1);
      });
      return btoa(utf8Bytes)
    },
    getService(data){
      let returnValue = "";
      Object.keys(data).forEach(key => {
        const value = data[key]
        if(key.toLocaleLowerCase() === SERVICE){
          returnValue = value;
        }
      });
      return returnValue;
    },
    grecaptchaCallback(token) {
      this.grecaptchaToken = token
      this.$nextTick(() => {
        this.form.submit()
      });
    },
    grecaptchaReadyCallback() {
      this.grecaptchaReady = true
    },
    grecaptchaExecute() {
      this.$root.$emit('grecaptcha-execute')
    }
  }
}
